import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-white font-bold text-lg mb-4">
              <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center text-white text-sm font-black">
                91
              </span>
              视频网站
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              91视频网站是领先的在线视频内容导航平台，汇聚海量优质视频资源，为用户提供便捷的视频发现和观看体验。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">视频分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/movie" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">电影大片</Link></li>
              <li><Link to="/category/tv" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">电视剧集</Link></li>
              <li><Link to="/category/variety" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">综艺节目</Link></li>
              <li><Link to="/category/anime" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">动漫动画</Link></li>
              <li><Link to="/category/documentary" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">纪录片</Link></li>
              <li><Link to="/category/music" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">音乐MV</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">发展历程</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">联系我们</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">加入我们</Link></li>
              <li><Link to="/article/ai-video-trends" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">最新资讯</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" />
                hello@ewqivah.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-500" />
                400-888-9191
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500" />
                北京市朝阳区望京SOHO
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="http://ewqivah.cn/" target="_blank" rel="noopener noreferrer nofollow" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微博">
                <i className="ri-weibo-line" />
              </a>
              <a href="http://ewqivah.cn/" target="_blank" rel="noopener noreferrer nofollow" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微信">
                <i className="ri-wechat-line" />
              </a>
              <a href="http://ewqivah.cn/" target="_blank" rel="noopener noreferrer nofollow" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line" />
              </a>
              <a href="http://ewqivah.cn/" target="_blank" rel="noopener noreferrer nofollow" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="哔哩哔哩">
                <i className="ri-video-line" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {currentYear} 91视频网站 All rights reserved. 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#" className="hover:text-foreground-400 transition-colors">用户协议</a>
            <a href="#" className="hover:text-foreground-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-foreground-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
